import React from "react";
import { Button, Form, Spinner, Row, Col, Container } from "reactstrap";
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import { useState } from "react";
import { signInAction } from "../store/actions/authAction";
import { useDispatch } from "react-redux";
import InputFields from "./InputFields";
import AuthHeader from "./AuthHeader";

const LoginForm = () => {
  const { darkMode, color } = useSelector((state) => state.global);
  const history = useHistory();
  const inputColor = darkMode ? "#ffffff" : "rgb(101 92 92)";
  const labelProps = {
    style: {
      color: darkMode ? "#ffffff" : "rgb(101 92 92)",
    },
  };
  const [signInData, setSignInData] = useState({
    email: "",
    password: "",
  });
  const handleChangeData = (e) => {
    const { name, value } = e.target;
    setSignInData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const theme = createTheme({
    palette: {
      secondary: {
        main: `${color ? color : "#000000"}`,
      },
    },
  });

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.user);

  let cartPath = localStorage.getItem("cartPath");
  const handleSubmit = () => {
    dispatch(
      signInAction(signInData, () => {
        cartPath ? history.push("/cart") : history.push(`/restaurants`);
      })
    );
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Container className="py-5">
      <Row className="d-flex flex-column justify-content-center align-items-center">
        <Form
          className={darkMode ? "px-3 pay-with-card" : "px-3 "}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          onKeyDown={handleKeyDown}
        >
          <Col className="mb-5">
            <AuthHeader darkMode={darkMode} title={"Login"} />
          </Col>
          <Col>
            <ThemeProvider theme={theme}>
              <InputFields
                labelName={"Enter Email"}
                type={"email"}
                name={"email"}
                value={signInData.email}
                labelProps={labelProps}
                inputColor={inputColor}
                handleChangeData={handleChangeData}
                darkMode={darkMode}
              />
              <InputFields
                labelName={"Enter Password"}
                type={"password"}
                name={"password"}
                value={signInData.password}
                labelProps={labelProps}
                inputColor={inputColor}
                handleChangeData={handleChangeData}
                darkMode={darkMode}
              />
            </ThemeProvider>
            {}
            <Button
              className="py-3 mt-4 w-100 auth__btn"
              style={{ background: `${color}` }}
              type="submit"
              disabled={loading}
            >
              {loading ? <Spinner size="md" /> : `${"Login"}`}
            </Button>
            {}

            <p className="mt-3 text-center" style={{ color: inputColor }}>
              Don’t have an account?{" "}
              <span
                className="cursor-pointer"
                style={{ color: `${color}` }}
                onClick={() => history.push("/register")}
              >
                Register Now
              </span>
            </p>
            <div className="mx-2 d-flex justify-content-between">
              <Link to="/main" className="pointer">
                <p>Go Back</p>
              </Link>
              <Link to="/forget-password" className="pointer">
                <p>Forgot password?</p>
              </Link>
            </div>
          </Col>
        </Form>
      </Row>
    </Container>
  );
};

export default LoginForm;
